import { Command } from 'commands/Commands';

export class ChangeCtrLink extends Command {
  type: string = 'Member.ChangeCtrLink';
  priority = 100;
}
